export default __webpack_public_path__ + "static/media/user.30b38e88.svg";